import {Container} from '@mantine/core'
import {createFileRoute, redirect} from '@tanstack/react-router'

import {validateJobListSearch} from '../../../jobs/jobs-search'
import {ProjectsHubPage} from '../../../projects/projects-hub-page'
import {validateProjectListSearch} from '../../../projects/projects-search'

export const Route = createFileRoute('/_app/projects/')({
    validateSearch: validateProjectListSearch,
    beforeLoad: ({location}) => {
        const rawSearch = new URLSearchParams(location.searchStr)
        if (rawSearch.get('tab') === 'jobs') {
            throw redirect({
                to: '/jobs',
                search: validateJobListSearch(Object.fromEntries(rawSearch)),
                replace: true,
            })
        }
    },
    component: ProjectsRoute,
})

function ProjectsRoute() {
    return (
        <Container size="lg" py="xl">
            <ProjectsHubPage />
        </Container>
    )
}
